import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import HeaderComponent from "../Header/HeaderComponent";
import { connect } from "react-redux";
import { UserData } from "../../DataStore";
import MainBanner from "../Banners/MainBanner";
import FeaturedGames from "../General/FeaturedGames";
import InnerBanner from "../General/InnerBanner";
import FooterComponent from "../Footer/FooterComponent";
import PoyaBanneer from "../Poya/PoyaBanneer";
import CryptoBanner from "../Poya/CryptoBanner";
import LowBalanceBanner from "../Modal/LowBalance/LowBalanceBanner";
import CashierModalWrapper from "../Modal/CashierModal/CashierModalWrapper";
import GamesWrapper from "../General/GameboardWrapper";
import Promotions from "./Promotions";
import SportsBetArea from "./SportsBetArea";
import UserInfo from "../Header/UserInfo";
import ChangePasswordComponent from "../Modal/GeneralModal/ChangePasswordComponent";
import { useAtom } from "jotai";
import MobileMainBanner from "../Banners/MobileMainBanner";
import { fetchTournamentEligibility } from "../../DataStore";

import { preLoader } from "../../DataStore/atom";

const Lobby = ({
  opencashier,
  getUserData,
  userData,
  tournamentEligibility,
  getTournamentEligibility,
  selectedGameAreaType,
  setSelectedGameType,
  modalType,
  modalStatus,
  openPopup,
  closePopup,
  generalModalStatus,
  generalModalType,
  openGeneralModal,
  gameWrapperArea,
  setCashierType,
}) => {
  const [preLoaderCoin, setPreLoader] = useAtom(preLoader);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTournamentModalOpen, setIsTournamentModalOpen] = useState(false);
  const tournamentCanvasRef = useRef(null);
  const hasHandledTournamentAfterLoginRef = useRef(false);
  const tournamentEligibilityRetryRef = useRef(0);

  const userDta = userData.data.data1;
  const userSession = userData.data.session;
  const history = useHistory();
  const checkLogin = () => {
    !localStorage.getItem('login')&&history.push('/')
  };
  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const closeTournamentModal = () => {
    setIsTournamentModalOpen(false);
  };

  const goToTournamentTabFromModal = () => {
    closeTournamentModal();

    if (typeof setSelectedGameType === "function") {
      if (history.location?.pathname !== "/lobby") {
        history.push("/lobby");
      }
      setSelectedGameType("BallysTournament");

      window.setTimeout(() => {
        gameWrapperArea?.current?.scrollIntoView?.({ block: "start" });
      }, 0);
      return;
    }

    history.push("/BallysTournament");
  };

  useEffect(() => {
    if(userDta?.did_change_password == false){
      openModal()
    }
  }, [userDta]);
  useEffect(() => {
    checkLogin();
    getUserData();
    closePopup();
  }, []);

  useEffect(() => {
    const shouldShow = localStorage.getItem("tournament_popup_after_login") === "1";
    const debugTournamentPopup =
      localStorage.getItem("debug_tournament_popup") === "1";

    if (debugTournamentPopup) {
      // eslint-disable-next-line no-console
      console.log("[TournamentPopup] effect", {
        shouldShow,
        handled: hasHandledTournamentAfterLoginRef.current,
        isTournamentModalOpen,
        loading: tournamentEligibility?.loading,
        eligible: tournamentEligibility?.eligible,
        tournamentId: tournamentEligibility?.tournamentId,
        eligibilityLength: Array.isArray(tournamentEligibility?.eligibility)
          ? tournamentEligibility.eligibility.length
          : null,
        err: tournamentEligibility?.err,
        username: userSession?.username,
      });
    }
    if (!shouldShow) return;
    if (hasHandledTournamentAfterLoginRef.current) return;

    if (isTournamentModalOpen) return;

    if (tournamentEligibility?.loading) return;

    if (tournamentEligibility?.err) {
      if (
        typeof getTournamentEligibility === "function" &&
        tournamentEligibilityRetryRef.current < 2
      ) {
        tournamentEligibilityRetryRef.current += 1;
        const retryMs = tournamentEligibilityRetryRef.current === 1 ? 1200 : 2500;
        const retryId = window.setTimeout(() => {
          getTournamentEligibility();
        }, retryMs);
        return () => window.clearTimeout(retryId);
      }
      return;
    }

    const hasEligibilityResult =
      !tournamentEligibility?.loading &&
      (tournamentEligibility?.eligibility !== null ||
        tournamentEligibility?.tournamentId !== null ||
        Boolean(tournamentEligibility?.err));

    if (!hasEligibilityResult) {
      if (typeof getTournamentEligibility === "function") {
        getTournamentEligibility();
      }
      return;
    }

    if (Boolean(tournamentEligibility?.eligible)) {
      setIsTournamentModalOpen(true);
    }

    localStorage.removeItem("tournament_popup_after_login");
    hasHandledTournamentAfterLoginRef.current = true;
  }, [
    userSession?.username,
    isTournamentModalOpen,
    tournamentEligibility?.loading,
    tournamentEligibility?.eligible,
    tournamentEligibility?.eligibility,
    tournamentEligibility?.tournamentId,
    tournamentEligibility?.err,
    getTournamentEligibility,
  ]);

  useEffect(() => {
    if (!isTournamentModalOpen) return;

    const canvas = tournamentCanvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const container = canvas.parentElement;
    if (!container) return;

    let ambientParticles = [];
    let burstParticles = [];
    let rafId = null;
    let burstIntervalId = null;
    let destroyed = false;

    function resizeCanvas() {
      const nextWidth = container.clientWidth;
      const nextHeight = container.clientHeight;
      if (!nextWidth || !nextHeight) return;
      canvas.width = nextWidth;
      canvas.height = nextHeight;
    }

    window.addEventListener("resize", resizeCanvas);
    resizeCanvas();

    class BoxAmbientParticle {
      constructor() {
        this.reset();
        this.y = Math.random() * canvas.height;
      }
      reset() {
        this.x = Math.random() * canvas.width;
        this.y = canvas.height + 10;
        this.size = Math.random() * 1.5 + 1;
        this.speedY = Math.random() * -0.8 - 0.2;
        this.speedX = Math.random() * 0.4 - 0.2;
        this.opacity = Math.random() * 0.5 + 0.1;
      }
      update() {
        this.y += this.speedY;
        this.x += this.speedX;
        if (this.y < -10 || this.x < -20 || this.x > canvas.width + 20) {
          this.reset();
        }
      }
      draw() {
        ctx.save();
        ctx.globalAlpha = this.opacity;
        ctx.fillStyle = "#d4af37";
        ctx.shadowColor = "rgba(212, 175, 55, 0.55)";
        ctx.shadowBlur = 8;
        ctx.beginPath();
        if (this.size > 3.5) {
          ctx.rect(this.x, this.y, this.size, this.size);
        } else {
          ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        }
        ctx.fill();
        ctx.restore();
      }
    }

    class BoxBurstParticle {
      constructor(originX, originY) {
        const angle = Math.random() * Math.PI * 2;
        const speed = Math.random() * 1.8 + 0.6;
        this.x = originX;
        this.y = originY;
        this.vx = Math.cos(angle) * speed;
        this.vy = Math.sin(angle) * speed;
        this.size = Math.random() * 2.2 + 0.8;
        this.opacity = 1;
        this.fade = Math.random() * 0.03 + 0.015;
      }
      update() {
        this.x += this.vx;
        this.y += this.vy;
        this.vy += 0.01;
        this.opacity -= this.fade;
      }
      draw() {
        ctx.save();
        ctx.globalAlpha = Math.max(0, this.opacity);
        ctx.fillStyle = "#ffffff";
        ctx.shadowColor = "rgba(243, 224, 155, 0.85)";
        ctx.shadowBlur = 10;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }
    }

    function initAmbient() {
      const particleCount = 160;
      ambientParticles = Array.from({ length: particleCount }, () => new BoxAmbientParticle());
    }

    function triggerInternalBurst() {
      if (!canvas.width || !canvas.height) return;
      const originX = canvas.width * 0.5 + (Math.random() * 120 - 60);
      const originY = canvas.height * 0.42 + (Math.random() * 80 - 40);
      const count = 18;
      for (let i = 0; i < count; i++) {
        burstParticles.push(new BoxBurstParticle(originX, originY));
      }
    }

    initAmbient();

    function animate() {
      if (destroyed) return;
      if (!canvas.width || !canvas.height) resizeCanvas();

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      ambientParticles.forEach((p) => {
        p.update();
        p.draw();
      });

      burstParticles.forEach((p) => {
        p.update();
        p.draw();
      });
      burstParticles = burstParticles.filter((p) => p.opacity > 0);

      rafId = window.requestAnimationFrame(animate);
    }

    rafId = window.requestAnimationFrame(animate);
    burstIntervalId = window.setInterval(() => {
      triggerInternalBurst();
    }, 2600);

    return () => {
      destroyed = true;
      window.removeEventListener("resize", resizeCanvas);
      if (rafId) window.cancelAnimationFrame(rafId);
      if (burstIntervalId) window.clearInterval(burstIntervalId);
    };
  }, [isTournamentModalOpen]);
  useEffect(() => {
    setPreLoader(true);
    const timer = setTimeout(() => {
      setPreLoader(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  const [cashierPopupStatus, setCashierPopupStat] = useState("inactive");
    let demoCashierType = ""
  demoCashierType = !userData.isLoading && userData?.data?.data1?.user_type !== "demo" ?  "deposit" : "transfer"
  const goToCashier = (type = demoCashierType) => {
    setCashierType(type);
    history.push("/cashier");
  };
  const cashierPopupActions = (type) => {
    switch (type) {
      case "active":
        setCashierPopupStat("active");
        break;
      case "inactive":
        setCashierPopupStat("inactive");
        break;
      default:
        setCashierPopupStat("inactive");
    }
  };
  const chrck = () => {
   alert()
  };
  return (
    <div style={{position: "relative"}}>
      {isTournamentModalOpen ? (
        <div
          className="modal showModal show"
          role="dialog"
          aria-modal="true"
          style={{ display: "block", backgroundColor: "#000000a1", zIndex: 1060 }}
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) closeTournamentModal();
          }}
        >
          <div className="modal-dialog modal-dialog-centered modal-xl showModalcontent">
            <div className="modal-content popupBg" style={{ backgroundColor: "transparent" }}>
              <div className="modal-header">
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  style={{ backgroundColor: "white" }}
                  onClick={(e) => {
                    e.preventDefault();
                    closeTournamentModal();
                  }}
                />
              </div>
              <div className="modal-body p-0">
                <div
                  className="tournament-frame-box"
                  role="button"
                  tabIndex={0}
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.preventDefault();
                    goToTournamentTabFromModal();
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      goToTournamentTabFromModal();
                    }
                  }}
                >
                  <svg className="border-svg" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                      <linearGradient
                        id="gold-gradient-lobby"
                        x1="0%"
                        y1="0%"
                        x2="100%"
                        y2="100%"
                      >
                        <stop offset="0%" stopColor="#aa7c11" />
                        <stop offset="30%" stopColor="#f3e09b" />
                        <stop offset="50%" stopColor="#ffffff" />
                        <stop offset="70%" stopColor="#d4af37" />
                        <stop offset="100%" stopColor="#aa7c11" />
                      </linearGradient>
                    </defs>
                    <rect className="border-rect" rx="8" style={{ stroke: "url(#gold-gradient-lobby)" }} />
                  </svg>

                  <canvas
                    ref={tournamentCanvasRef}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      zIndex: 1,
                      pointerEvents: "none",
                    }}
                  />

                  <div className="content-layer">
                    <div className="mb-3">
                      <span className="suit-icon">♦</span>
                      <span className="suit-icon mx-2">♣</span>
                      <span className="suit-icon">♥</span>
                    <span className="suit-icon mx-2">♠</span>

                    </div>

                    <h3 className="anim-congrats text-uppercase">Congratulations</h3>

                    <p className="anim-selected">YOU HAVE BEEN SELECTED</p>

                    <span className="anim-baccarat m-0">ONLINE BACCARAT TOURNAMENT</span>

                    <div>
                      <span className="anim-year">2026</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {/* header area */}
      <HeaderComponent
        userData={userData}
        login={true}
        openPopup={openPopup}
        openGeneralModal={openGeneralModal}
        setCashierType={setCashierType}
        setSelectedGameType={setSelectedGameType}
      />
      {/* banner area */}
      <MainBanner login={true} />
      <MobileMainBanner login={false} />
      {/* featured games */}
      <FeaturedGames
        login={true}
        openPopup={openPopup}
        setSelectedGameType={setSelectedGameType}
        openGeneralModal={openGeneralModal}
        goToCashier={goToCashier}
      />
      {/* inner banner */}
      {/* <InnerBanner login={true} /> */}
      {/* <Promotions
        selectedGameAreaType={selectedGameAreaType}
        login={true}
        gameWrapperArea={gameWrapperArea}
      /> */}
      {/* game tabs */}
      <GamesWrapper
        selectedGameAreaType={selectedGameAreaType}
        login={true}
        gameWrapperArea={gameWrapperArea}
      />
      {/* <SportsBetArea
        selectedGameAreaType={selectedGameAreaType}
        login={true}
        gameWrapperArea={gameWrapperArea}
      /> */}
      {/* footer area */}
      <FooterComponent
        login={true}
        openPopup={openPopup}
        generalModalStatus={generalModalStatus}
        closePopup={closePopup}
        generalModalType={generalModalType}
        openGeneralModal={openGeneralModal}
        goToCashier={goToCashier}
      />
      {/* cashier modal */}
      {/* <CashierModalWrapper
        userData={userData}
        modalType={modalType}
        closePopup={closePopup}
        status={modalStatus}
      /> */}
      <UserInfo
        openPopup={openPopup}
        userSession={userSession}
        userDta={userDta}
        openGeneralModal={openGeneralModal}
        goToCashier={goToCashier}
        setSelectedGameType={setSelectedGameType}
      />
      
      <PoyaBanneer />
      <CryptoBanner />
      <LowBalanceBanner userData={userData}/>
      <ChangePasswordComponent isOpen={isModalOpen} onClose={closeModal} close={true}/>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    tournamentEligibility: state.TournamentEligibility,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserData: () => dispatch(UserData()),
    getTournamentEligibility: () => dispatch(fetchTournamentEligibility()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Lobby);
